<template>
    <div>
        <div class="card" :style="isProductPage ? 'box-shadow: none' : ''" @mouseleave="handleMouseLeave">
            <div class="cardInner" style="/*background-color:#e9e9e9;*/">
                <a :href=" isProductPage ? 'javascript:void(0)' : '/catalogue' + product.url">  
                  
                    <img v-if="isProductPage" v-show="hdImageLoaded[selectedImage ? selectedImage : product.image]" @load="onHdImageLoad(selectedImage ? selectedImage : product.image)" 
                            class="product-image product-image-disable-hover"  
                            v-bind:src="'/api/image/get/product/' + (selectedImage ? selectedImage : product.image)" 
                             @touchstart="handleTouchStart"
                             @touchmove="handleTouchMove"
                             @touchend="handleTouchEnd"/>

                            
                             <div v-if="isProductPage && (selectedImage || product.image)" v-show="!hdImageLoaded[selectedImage ? selectedImage : product.image]" class="row product-image" style="height:418px;" >
                                <div class="col-12 text-center  mx-auto my-auto">
                                    <b-spinner class="custom-spinner"></b-spinner>
                                </div>
                             </div>
                             
                    
                    <img  v-if="!isProductPage" v-show="!hdImageLoaded[selectedImage ? selectedImage : product.image]" class="product-image"  v-bind:src="'/api/image/get/product/small/' + (selectedImage ? selectedImage : product.image)"
                             @mouseover="toggleComponent"
                             @touchstart="handleTouchStart"
                             @touchmove="handleTouchMove"
                             @touchend="handleTouchEnd"
                            />
                </a>
                <div v-if="isShowWishlistSize" class="bottomWishlistComponent"> 

                    <div v-if="!currentUser" style="opacity:0.9">
                        <div class="text-center font-weight-bold bg-dark pt-1 pb-1 pr-1 p-1 text-warning font-size-14" style="color: #fff;" >Vous devez être connecté pour gérer votre wishlist</div>
                            <!-- <div class="text-center font-weight-bold bg-dark pt-1 pb-1" style="color: #fff;" ><a class="text-warning font-size-14" href="/login">pour gérer votre wishlist</a></div> -->
                    </div>
                    
                    <div v-else >
                        <div class="text-center bg-dark font-weight-bold pt-1 pb-1" style="color: #fff;" > Ajouter à votre Wishlist ?</div>
                        <sizeComponent :sizes="product.sizes" @size-selected="updateWishlistSelectedSize" :available=true></sizeComponent>
                    </div>
                    
                </div>
                <div v-if="isShowWishlistColor" class="colorWishlistComponent">

                    <div class="text-center font-weight-bold bg-dark pt-1 pb-1" style="color: #fff;" > Ajouter à votre Wishlist ?</div>
                        <ColorComponent  :sizesList="product.sizes" :selectedSize="selectedSize" @mouseover="onColorComponentMouseOver" @color-selected="updateWishlistSelectedColor" :available=true ></ColorComponent>
                </div>
                <div v-if="isShowAddToWishList" class="bottomWishlistComponent" >
                    <AddToCartButton message="Ajouté(s) dans le wishList" :selectedSize="WishlistselectedSize" :selectedColor="selectedWishlistVariant" :productID="product.id"></AddToCartButton>
                </div>


                <div v-if="showBottomComponent && isShowSize" class="bottomComponent" :class="{ 'bottomComponent-hovered': showBottomComponent && isShowSize && isMobile }"> 
                    <sizeComponent :sizes="product.sizes" @size-selected="updateSelectedSize"></sizeComponent>
                </div>
                <div v-if="showBottomComponent && isShowColor" class="bottomComponent"  :class="{ 'bottomComponent-hovered': showBottomComponent && isShowColor && isMobile }"  >
                    <ColorComponent :sizesList="product.sizes" :selectedSize="selectedSize" @mouseover="onColorComponentMouseOver" @color-selected="updateSelectedColor" @close="onCloseColorComponent"></ColorComponent>
                </div>
                <div v-if="showBottomComponent && isShowAddToCart" class="bottomComponent"  >
                    <AddToCartButton message="Ajouté(s) dans le panier"  :selectedSize="selectedSize" :selectedColor="selectedVariant" :productID="product.id"></AddToCartButton>
                </div>
            </div>
            <div title="Ajouter au comparateur" class="compareWrapper" @click="addTocompare(product.ref)">
                <img class="compareIcon1" alt="" src="../assets/images/compare.jpg"  />
            </div>

            <div title="Image suivante" class="next-image-right" @click="nextImage()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#568" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.4001 11.2899C13.4939 11.3829 13.5683 11.4935 13.619 11.6154C13.6698 11.7372 13.6959 11.8679 13.6959 11.9999C13.6959 12.132 13.6698 12.2627 13.619 12.3845C13.5683 12.5064 13.4939 12.617 13.4001 12.7099L8.81014 17.2899C8.71641 17.3829 8.64202 17.4935 8.59125 17.6154C8.54048 17.7372 8.51434 17.8679 8.51434 17.9999C8.51434 18.132 8.54048 18.2627 8.59125 18.3845C8.64202 18.5064 8.71641 18.617 8.81014 18.7099C8.9975 18.8962 9.25095 19.0007 9.51514 19.0007C9.77933 19.0007 10.0328 18.8962 10.2201 18.7099L14.8101 14.1199C15.3719 13.5574 15.6875 12.7949 15.6875 11.9999C15.6875 11.2049 15.3719 10.4424 14.8101 9.87994L10.2201 5.28994C10.0339 5.1052 9.78248 5.00104 9.52014 4.99994C9.38853 4.99918 9.25807 5.0244 9.13623 5.07417C9.01439 5.12393 8.90358 5.19726 8.81014 5.28994C8.71641 5.3829 8.64202 5.4935 8.59125 5.61536C8.54048 5.73722 8.51434 5.86793 8.51434 5.99994C8.51434 6.13195 8.54048 6.26266 8.59125 6.38452C8.64202 6.50637 8.71641 6.61698 8.81014 6.70994L13.4001 11.2899Z" fill="#374957" :fill-opacity="0.5"/>
                </svg>
            </div>

            <div title="Image précédente" class="next-image-left" @click="previousImage()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5999 12.7101C10.5062 12.6171 10.4318 12.5065 10.381 12.3846C10.3303 12.2628 10.3041 12.1321 10.3041 12.0001C10.3041 11.868 10.3303 11.7373 10.381 11.6155C10.4318 11.4936 10.5062 11.383 10.5999 11.2901L15.1899 6.71006C15.2836 6.6171 15.358 6.5065 15.4088 6.38464C15.4596 6.26278 15.4857 6.13207 15.4857 6.00006C15.4857 5.86805 15.4596 5.73734 15.4088 5.61548C15.358 5.49362 15.2836 5.38302 15.1899 5.29006C15.0026 5.10381 14.7491 4.99927 14.4849 4.99927C14.2207 4.99927 13.9673 5.10381 13.7799 5.29006L9.18992 9.88006C8.62812 10.4426 8.31256 11.2051 8.31256 12.0001C8.31256 12.7951 8.62812 13.5576 9.18992 14.1201L13.7799 18.7101C13.9662 18.8948 14.2176 18.999 14.4799 19.0001C14.6115 19.0008 14.742 18.9756 14.8638 18.9258C14.9857 18.8761 15.0965 18.8027 15.1899 18.7101C15.2836 18.6171 15.358 18.5065 15.4088 18.3846C15.4596 18.2628 15.4857 18.1321 15.4857 18.0001C15.4857 17.868 15.4596 17.7373 15.4088 17.6155C15.358 17.4936 15.2836 17.383 15.1899 17.2901L10.5999 12.7101Z" fill="#374957" :fill-opacity="0.5"/>
                    </svg>
            </div>

        </div>
        <div class="priceCard pt-4">
            <div class="row pb-2">
                <div class="col-11">
                    <div class="titleClass ">{{ product.title }}</div>
                </div>
                <div class="col-1 text-right">
                    <img v-if="!this.currentUser || product.isInWishList == false" alt="" height="18px" src="../assets/icons/heart.svg" style="cursor:pointer;" title="Ajouter à votre Wishlist" @click="showAddToWishList()"/>
                    <img v-if="this.currentUser && product.isInWishList == true" alt="" height="18px" src="../assets/icons/heart-red.svg" style="cursor:pointer;"  title="Retirer de la Wishlist" @click="removeWishListByItem()" />
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-9 price font-weight-bold">
                    <span  v-if="product.priceDiscounted" > {{ product.priceDiscounted }} </span> 
                    <span v-if="product.discount" class="ml-1 line-through font-size-14 text-secondary" 
                            >{{ product.price }}</span>  
                </div>
                <div v-if="product.discount" class="col-3 my-auto text-right discount">
                    <span class="discountLabel">{{ product.discountStr }}</span>
                </div>
            </div>
            
            <div :class="isProductPage ? 'd-xl-none' : 'd-lg-none'" class="row mt-1 mb-2 ">

                <div class="col-12 text-right font-weight-bold" :class="selectedVariant ?  'text-dark' : 'text-danger' ">
                   
                    <!-- {{ (!selectedVariant || !selectedVariant.color ||!selectedVariant.color.name) && showAlert ? 'Veuillez Sélectionner une taille et une couleur' : '' }} -->

                    {{ selectedVariant ? 'Taille : ' + this.selectedSize + ', Couleur : ' + this.selectedVariant.color.name : '' }}
                </div>

                <div v-if="!selectedVariant" class="col-6">
                    <b-button variant=" w-100 font-size-18" 
                            @click="showSizesFromMobile()   "
                            style="border-radius:0px; border: 1px solid #ddd;" > 
                            Tailles <span class="font-size-14">({{ product && product.sizes ? Object.keys(product.sizes).length : ''}})</span>
                    </b-button>
                </div>

                <div v-if="selectedVariant" class="col-6"> 
                    <b-button variant=" w-100 font-size-18" 
                            @click="selectedVariant = null; showAlert=false;"
                            style="border-radius:0px; border: 1px solid #ddd;" > 
                            Annuler
                    </b-button>
                </div>

                <div class="col-6">
                    <b-button variant="dark w-100 font-size-18 font-weight-bold"
                            @click="addToCartFromMobile()" style="border-radius:0px; "   :disabled="(showAlert && !this.selectedSize) || (showAlert && !this.selectedVariant)"  >  
                            {{ selectedVariant ? 'Confirmer' : showAlert && !this.selectedSize ? 'Taille' : ( showAlert && !this.selectedVariant ? 'Couleur' : 'Ajouter' ) }}
                    </b-button>

                    
                    
                </div>

               
                <div v-if="isProductPage && product && product.lookGroupCode" class="col-12">
                    <b-button variant="outline-dark w-100 font-size-18 font-weight-bold bg-white text-dark" 
                            @click="openLook" style="border-radius:0px; border: 1px solid #ddd; border-top:0px;" > 
                            Voir le look
                    </b-button>
                </div>
            </div>
        
                    
        </div>
               

            
    </div>
</template>

<script>
import sizeComponent from "@/components/sizeComponent.vue"
import ColorComponent from "@/components/ColorComponent.vue"
import AddToCartButton from "@/components/addToCartButton.vue"
import WishList from "@/services/wishlist-api";
import ItemsApi from "@/services/items-api";


export default {
    name: "ProductCard",
    components: {
        sizeComponent, ColorComponent, AddToCartButton
    },
    props: {
        product: Object,

        isProductPage:{
          type:Boolean,
          default:false
        },
    },

    data() {
        return {
            isShowSize: false,
            isShowColor: false,
            isShowAddToCart:false,
            selectedSize: null,
            selectedVariant: null,
            showBottomComponent: false,

            selectedImage: null,

            WishlistselectedSize: null,
            selectedWishlistVariant: null,

            isShowWishlistSize: false,
            isShowWishlistColor: false,
            isShowAddToWishList:false ,

            //isHdImageLoaded: false,
            hdImageLoaded: {},
            
            isMobile: false,

            imageIndex: 0,


            startX: 0,
            currentX: 0,
            startY: 0,
            currentY:0,

            showAlert: false,
        };
    },

    computed: {
        currentUser() {
        return this.$store.getters['auth/currentUser'];
    },
    comparatorItems() {
        return this.$store.state.comparatorItems;
    },
    },

    methods: {

        openLook() {
            this.$emit('open-look', null);
        },

    handleTouchStart(event) {


        if (event.touches.length > 1) {
            this.startX = 0;
            this.currentX = 0;
            this.startY = 0;
            this.currentY = 0;
            return;
        }
      
        this.startX = event.touches[0].clientX;
        this.startY = event.touches[0].clientY;
        this.currentX = this.startX;
        this.currentY = this.startY;
    },

    handleTouchMove(event) {

        if (event.touches.length > 1) {
            this.startX = 0;
            this.currentX = 0;
            this.startY = 0;
            this.currentY = 0;
            return;
        }

      this.currentX = event.touches[0].clientX;
      this.currentY = event.touches[0].clientY;
    },

    handleTouchEnd(event) {

        if (event.touches.length > 1) {
            this.startX = 0;
            this.currentX = 0;
            this.startY = 0;
            this.currentY = 0;
            return;
        }

      const diffX = this.currentX - this.startX;
      const diffY = this.currentY - this.startY;

      

      if (( Math.abs(diffX) > Math.abs(diffY) ) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.previousImage();
        } else {
          this.nextImage();
        }
      }

      this.startX = 0;
      this.currentX = 0;
      this.currentY = 0;
      this.startY = 0;
    },


    previousImage() {
    const images = Array.from(this.getImages(this.selectedVariant));
    
    if (images && images.length > 0) {
        // Decrement imageIndex and handle wrap-around
        this.imageIndex = (this.imageIndex - 1 + images.length) % images.length;
        this.selectedImage = images[this.imageIndex];
    } else {
        this.imageIndex = 0;
        this.selectedImage = this.product.image;
    }
},

        nextImage() {

            const images = Array.from(this.getImages(this.selectedVariant));

            if (images && images.length > 0) {
                this.imageIndex = (this.imageIndex + 1) % images.length;
                this.selectedImage = images[this.imageIndex];
            } else {
                this.imageIndex = 0;
                this.selectedImage = this.product.image;
            }
        },



        getImages() {
            if (!this.product || !this.product.sizes) {
                return null;
            }
            
            const colorId = this.selectedVariant ? this.selectedVariant.color.id : this.product.color.id;
            const data = this.product.sizes;

            const imagesSet = new Set();
                        for (const size in data) {
                    for (const item of data[size]) {
                        if (colorId === null || (item.color && item.color.id === colorId)) {
                            if (item.itemsVariantImages) {
                                item.itemsVariantImages.forEach(image => imagesSet.add(image));
                            }
                        }
                    }
            }
            return imagesSet;
        },



















        addToCartFromMobile() {

            if (!this.selectedVariant) {
                this.showAlert=true;
                this.showSizesFromMobile()
                return;
            } 

            this.showAlert=false;
            this.addToCart();
        },

        showSizesFromMobile() {

            this.selectedSize=null;

            this.isShowWishlistColor = false
            this.isShowWishlistSize = false
            this.isShowAddToWishList = false

            this.showBottomComponent = true;
            if(!this.selectedSize){
                this.isShowSize = true;
            }

            //this.toggleComponent(); 
            this.onCloseColorComponent();
            this.isMobile=true
        },

        onHdImageLoad(image) {
            if (!image) {
                image = 'null';
            }
            this.$set(this.hdImageLoaded, image, true);
        },

        showAddToWishList(){

            this.showBottomComponent = false
      
            if(this.isShowWishlistColor){
                this.isShowWishlistColor = false
                this.isShowWishlistSize = false
            }
            else{
                this.isShowWishlistSize = !this.isShowWishlistSize 
            }

        },

        addTocompare(itemRef){
            this.$store.dispatch('addToComparator', itemRef)
        },

        isMobileDetected() {
            if (this.isProductPage) {
                return window.innerWidth < 1200 ;
            } else {

                return window.innerWidth <= 992 ;
            }
        },

        toggleComponent() {

            /*const images = this.getImagesOfVariant(this.selectedVariant);

            if (images && images.length && images.length > 1) {
                this.selectedImage = images[1];
            }*/

            if (this.isProductPage) {
                return;
            }

            if (this.isMobileDetected()) {
                return;
            }

            this.isShowWishlistColor = false
            this.isShowWishlistSize = false
            this.isShowAddToWishList = false

            this.showBottomComponent = true;
            if(!this.selectedSize){
                this.isShowSize = true;
            }
        },

        setVisitItem(){
            const isCatalogScreen = 0
            ItemsApi.setVisitItem(this.product.id ,isCatalogScreen)

        },

        updateSelectedSize(size) {

            this.setVisitItem()
            this.selectedSize = size;
            this.isShowSize=false;

            this.isAddToCartInProgress=false;
            this.isShowColor=true;
        },

        updateSelectedColor(color) {
            this.selectedVariant = color;
            
            if (!this.isMobile) {
                this.isAddToCartInProgress=true;
                this.addToCart();
            }

            if (this.selectedVariant) {
                const images = this.getImagesOfVariant(this.selectedVariant)
                this.selectedImage = images && images.length ? images[0] : this.product.image;
            }
        },

        addToCart() {

            this.$store.dispatch('addToCart', [{ itemVariantId: this.selectedVariant.id, quantity: 1 }])
                .then(( ) => { 
                    this.isShowColor=false;
                    this.isShowAddToCart=true;
                    setTimeout(() => {this.isShowAddToCart = false;}, 2000);
                })
                .catch((error) => {
                    console.log(error)
                }).finally( () => {
                    this.isAddToCartInProgress= false;
                    this.selectedVariant = null; 
                });
        },

        updateWishlistSelectedSize(size) {
            this.showBottomComponent = false
            this.WishlistselectedSize = size;
            this.isShowWishlistSize=false;
            this.isShowWishlistColor=true;
        },

        updateWishlistSelectedColor(color) {
            this.showBottomComponent = false
            this.selectedWishlistVariant = color;
            this.isShowWishlistColor=false;

            this.addToWishList()
       
        },

        addToWishList(){
            this.showBottomComponent = false
            this.isShowAddToWishList = true 

              WishList.addToWishlist(this.selectedWishlistVariant.id).then(
                (result) =>{
                    if(result){
                        this.product.isInWishList = true
                    }
                } 
            )  
        },

        removeWishListByItem(){
            WishList.removeWishListByItem(this.product.id).then(
                (result) =>{
                    if(result){
                        this.product.isInWishList = false
                    }
                } 
            )  

        },

        onCloseColorComponent() {
            this.isShowSize=true;
            this.isShowColor=false;

            this.selectedImage = this.product.image;
        },

        onColorComponentMouseOver(variant) {

            if(this.isMobile || this.isMobileDetected()) {
                return;
            }

            const images = this.getImagesOfVariant(variant)
            this.selectedImage = images && images.length ? images[0] : this.product.image;
        },

        getImagesOfVariant(variant) {
            const colorId = variant ? variant.color.id : null;
            const data = this.product.sizes;
            const imagesSet = new Set();
                        for (const size in data) {
                    for (const item of data[size]) {
                        if (colorId === null || (item.color && item.color.id === colorId)) {
                            if (item.itemsVariantImages) {
                                item.itemsVariantImages.forEach(image => imagesSet.add(image));
                            }
                        }
                    }
            }

            return Array.from(imagesSet);
        },

        handleMouseLeave() {

        if (this.isMobile || this.isMobileDetected()) {
            return;
        }

           this.onCloseColorComponent();
           this.showBottomComponent = false;
        }
    },
};
</script>

<style scoped>
.price {
    /*position: absolute;
    height: 7.97%;
    width: 31.91%;
    top: 91.63%;
    left: 0.71%;*/
    font-size: 16px;
    line-height: 20px;
    
    font-family: Poppins;
    color: #121212;
}

/*.discountedPrice {
    position: absolute;
    height: 7.97%;
    width: 28.37%;
    top: 92.03%;
    left: 32.98%;
    font-size: 14px;
    text-decoration: line-through;
    line-height: 40px;
    font-weight: 600;
    font-family: Poppins;
}*/

/*.discount {
    position: absolute;
    top: 92.03%;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}*/

.discountLabel {
    /*position: relative;*/
    /*margin-left: 0.71%;*/
    border-radius: 8px;
    background-color: #ff0000;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    padding: 2px 8px 2px 8px;
}



.product-image {
    width: 100%;       
    height: auto;     
    object-fit: cover; 
    transition: transform 1s ease-in-out;
}

.product-image:hover {
    transform: scale(1.05);
}

.product-image-disable-hover:hover {
    transform: scale(1);
}

.cardInner {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 15.65%;
    left: 0%;

    overflow: hidden;
}

.compareIcon1 {
    position: relative;
    width: 16px;
    height: 16px;
    overflow: hidden;
    flex-shrink: 0;
}

.compareWrapper {
    position: absolute;
    height: 5%;
    max-height:40px;
    width: 8.08%;
    max-width:40px;
    top: 1%;
    right: 1%;
    bottom: 90.23%;
    /*left: 84.19%;*/
    border-radius: 50px;
    background-color: #fff;
    border: 0.5px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 3px;
    cursor: pointer;
}

.next-image-right {
    position: absolute;
    height: 5.79%;
    width: 4.5%;
    top: 0%;
    /*right: 84.19%;*/
    bottom: 90.23%;
    left: 4%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1px;
    cursor: pointer;
}

.next-image-left {
    position: absolute;
    height: 5.79%;
    width: 4.5%;
    top: 0%;
    /*right: 90%; */
    bottom: 90.23%;
    left: 1%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1px;
    cursor: pointer;
}

.priceCard {
    position: relative;
    width: 100%;
}

.card {
    position: relative;
    width: 100%;
    /*height: 499px;*/
    text-align: left;
    font-size: 16px;
    color: #121212;
}

.titleClass {
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
}

.bottomWishlistComponent {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    justify-content: space-around;
    opacity: 1; /* Initially hide the component */
    transition: opacity 0.3s ease; /* Add transition effect for smooth display */
}

.colorWishlistComponent {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    justify-content: space-around;
    opacity: 1; /* Initially hide the component */
    transition: opacity 0.3s ease; 
    background-color: #fff;
}

.bottomComponent {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    opacity: 0; 
    transition: opacity 0.3s ease;
}

.bottomComponent-hovered {
    opacity: 1;
}

.cardInner:hover .bottomComponent {
    opacity: 1;
}

.custom-spinner {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: 8px solid #f3f3f3; 
    border-top: 8px solid #121212;
    animation: spin 1s linear infinite;
    /*position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);*/
}

</style>
